import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useState } from 'react';
import { findCurrentLocation } from './services/utils';
var RouterContext = createContext(null);
/**
 * The base component that will provide the Router context
 */
var Router = function (_a) {
    var _b = _a.queryKey, queryKey = _b === void 0 ? "react_static_url_router" : _b, children = _a.children;
    var currentLocation = function () { return findCurrentLocation(queryKey); };
    var _c = useState(currentLocation()), location = _c[0], setLocation = _c[1];
    var navigate = function (newLocation) {
        var url = new URL(window.location.href);
        url.searchParams.set(queryKey, newLocation);
        window.history.pushState({}, "", url);
        setLocation(newLocation);
    };
    var handleHashChange = useCallback(function () {
        setLocation(currentLocation());
    }, []);
    useEffect(function () {
        window.addEventListener("popstate", handleHashChange);
        return function () { return window.removeEventListener("popstate", handleHashChange); };
    }, [handleHashChange]);
    var contextValue = { location: location, navigate: navigate };
    return (_jsx(RouterContext.Provider, { value: contextValue, children: children }));
};
export { Router, RouterContext };
